import React, { Suspense, type JSX } from "react";
import { useRoutes } from "react-router-dom";
import LoadingPage from "../components/LoadingPage";

const withSuspense = (
  Component: React.LazyExoticComponent<() => JSX.Element>
) => (
  <Suspense fallback={<LoadingPage />}>
    <Component />
  </Suspense>
);

const Home = React.lazy(() => import("../pages/Home"));
const About = React.lazy(() => import("../pages/About"));
const PrivacyPolicy = React.lazy(() => import("../pages/PrivacyPolicy"));
const WashablePaper = React.lazy(() => import("../pages/WashablePaper"));
const Products = React.lazy(() => import("../pages/Products"));
const Product = React.lazy(() => import("../pages/Product"));
const Personalization = React.lazy(() => import("../pages/Personalization"));

export const MainRoutes = () =>
  useRoutes([
    {
      path: "/",
      element: (
        <Suspense fallback={<LoadingPage />}>
          <Home />
        </Suspense>
      ),
    },
    { path: "/sobre", element: withSuspense(About) },
    { path: "/politica-de-privacidade", element: withSuspense(PrivacyPolicy) },
    { path: "/papel-lavavel", element: withSuspense(WashablePaper) },
    { path: "/produtos", element: withSuspense(Products) },
    { path: "/produtos/:slug", element: withSuspense(Product) },
    { path: "/personalizacao", element: withSuspense(Personalization) },
  ]);
